/**
 * Die Auswahl der Nutzungsart (`unit-create-usage-type` / `unit-edit-usage-type`,
 * Spec 02a, „Reiter Stammdaten"). Die Optionen kommen von `GET
 * /units/usage-types` — der Client pflegt keine eigene Zuordnung von Werten
 * auf deutsche Bezeichnungen (`ARCHITECTURE.md` 5).
 *
 * Die Darstellung liegt in `components/EnumSelectField`; hier bleibt nur, was
 * fachlich ist: die Abfrage und die Beschriftung.
 */

import { useUsageTypes } from '@/features/properties/api'
import { EnumSelectField } from '@/components/EnumSelectField'
import type { FieldError } from '@/components/FormField'

interface UsageTypeFieldProps {
  readonly testId: string
  readonly errorPrefix: string
  readonly value: string
  readonly onChange: (value: string) => void
  readonly error: FieldError | undefined
  readonly disabled?: boolean
}

export function UsageTypeField({
  testId,
  errorPrefix,
  value,
  onChange,
  error,
  disabled = false,
}: UsageTypeFieldProps) {
  const usageTypesQuery = useUsageTypes()

  return (
    <EnumSelectField
      label="Nutzungsart"
      testId={testId}
      apiField="usage_type"
      errorPrefix={errorPrefix}
      options={usageTypesQuery.data ?? []}
      isPending={usageTypesQuery.isPending}
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
    />
  )
}
